import { render, staticRenderFns } from "./danhSachSuKien.vue?vue&type=template&id=b5f04d4a&scoped=true&"
import script from "./danhSachSuKien.vue?vue&type=script&lang=js&"
export * from "./danhSachSuKien.vue?vue&type=script&lang=js&"
import style0 from "./danhSachSuKien.vue?vue&type=style&index=0&id=b5f04d4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f04d4a",
  null
  
)

export default component.exports